import { useState } from 'react';
import { Input } from 'antd';

// Required reason for going ahead despite the first-part warning; the value is
// handed to the modal's OK handler through `holder`.
export default function FirstPartReasonField({ t, holder }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  holder.setError = setError;

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        {t('firstPartReasonLabel', { ns: 'messages' })}
      </div>
      <Input.TextArea
        value={value}
        status={error ? 'error' : undefined}
        autoSize={{ minRows: 2, maxRows: 5 }}
        maxLength={1000}
        placeholder={t('firstPartReasonPlaceholder', { ns: 'messages' })}
        onChange={(e) => {
          setValue(e.target.value);
          holder.reason = e.target.value;
          if (e.target.value.trim()) setError(false);
        }}
      />
      {error ? (
        <div style={{ color: '#ff4d4f', marginTop: 4 }}>
          {t('firstPartReasonRequired', { ns: 'messages' })}
        </div>
      ) : null}
    </div>
  );
}
